/**
 * Kyle Rising — copy-to-clipboard buttons.
 *
 * Delegated from the document so any [data-kr-copy] added later works without
 * rebinding. Falls back to a hidden textarea and execCommand where the async
 * clipboard API is unavailable or blocked, which is common on non-HTTPS origins
 * — including the local preview.
 */
const RESET_MS = 2000;

async function copy(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();

    let ok = false;
    try {
      ok = document.execCommand('copy');
    } catch {
      ok = false;
    }

    field.remove();
    return ok;
  }
}

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-kr-copy]');
  if (!button) return;

  event.preventDefault();

  const copied = await copy(button.dataset.krCopy);
  const original = button.dataset.krCopyLabel || button.textContent;

  button.dataset.krCopyLabel = original;
  button.textContent = copied ? 'Copied' : 'Press Ctrl+C';

  clearTimeout(button.krCopyTimer);
  button.krCopyTimer = setTimeout(() => {
    button.textContent = original;
  }, RESET_MS);
});
